import { ReactNode } from 'react'

export const SPATIAL = 'spatial'
export const CURSOR = 'cursor'

export type NavigationMode = 'spatial' | 'cursor'

export type NavigationModeContextValue = {
  isCursorMode: boolean
  lastFocusKey: string | undefined
  setLastFocusKey: (key: string) => void
}

export type NavigationModeProviderProps = {
  children: ReactNode
}
